import Reference from '@/fhirworks/types/Reference';
import merge from 'lodash/merge';
import DomainResource from './DomainResource';

/**
 * BN_MessageReaction custom resource — one participant's emoji reaction to one message.
 *
 * Withdrawing a reaction sets `active` to false; the row is never deleted, in keeping with the
 * rest of messaging. `thread` is denormalized off the message so every reaction in a conversation
 * can be read in one query instead of one per message.
 *
 * Who may read a reaction is decided by the reacted-to message's frozen `Communication.recipient`
 * list, which no AccessPolicy can express (a policy cannot join a reaction to its message). Hence
 * reads go through the `message-reactions` AidboxQuery and writes go through MessageReactionService.
 */
export default class BN_MessageReaction extends DomainResource {
    static __className = 'BN_MessageReaction';
    __objectStructure = {
        thread: Reference,
        message: Reference,
        participant: Reference,
        emoji: String,
        created: String,
        active: Boolean,
    };

    __objectDefaults = {
        active: true,
    };

    constructor(constructJson, className = 'BN_MessageReaction') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
